import { Button } from 'components/button/Button';
import { ProgressIndicator } from 'components/progressIndicator/progressIndicator';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { signOut } from 'reducers/auth';
import { closeModal } from 'reducers/modal';
import useCountdown from './useCountdown';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';

export const VirtualAssessmentsTimeoutModal = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation('Virtual+Assessments+Timeout+Modal', { i18n });

  const initialTime = 300;

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleCloseAndSignOut = () => {
    handleCloseModal();
    dispatch(signOut());
  };

  const onTimeEnd = () => {
    handleCloseAndSignOut();
  };

  const { minutes, seconds, remainingSeconds } = useCountdown({
    initialSeconds: initialTime,
    onTimeEnd,
  });

  return (
    <div className="VirtualAssessmentsTimeoutModal">
      <Formik initialValues={{}} onSubmit={() => {}}>
        <Form>
          <div className="VirtualAssessmentsTimeoutModal__content VirtualAssessmentsModalContent">
            <div className="VirtualAssessmentsTimeoutModal__timeoutCountdown">
              <ProgressIndicator
                value={remainingSeconds}
                total={initialTime}
                radius={50}
                strokeColor="$MainColor35"
                overrideText={`${minutes}:${
                  seconds < 10 ? `0${seconds}` : seconds
                }`}
              />
            </div>
            <div className="VirtualAssessmentsTimeoutModal__message">
              {t('SSCandidate_Virtual_Assessments_Timeout_Modal_Message')}
            </div>
          </div>
          <div className="ModalFooter">
            <Button
              priority="tertiary"
              type="button"
              onClick={handleCloseAndSignOut}
            >
              {t('SSCandidate_Virtual_Assessments_Timeout_Modal_Sign_Out')}
            </Button>
            <Button
              className="Discard"
              priority="primary"
              type="submit"
              onClick={handleCloseModal}
            >
              {t('SSCandidate_Virtual_Assessments_Timeout_Modal_Stay')}
            </Button>
          </div>
        </Form>
      </Formik>
    </div>
  );
};
